export default "__VITE_ASSET__CxMpzceG__"